module.exports = __webpack_public_path__ + "img/9788957982587.fa62d75d.jpg";